import SlideObjectInteractiveMap from './SlideObjectInteractiveMap';

export default SlideObjectInteractiveMap;
